<template>
  <div class="all-requests">
    <div class="mt-2" style="text-align: right">
      <v-row>
        <v-col cols="3">
          
      <div class="">
        <v-progress-circular
          :size="30"
          v-if="chart_loading"
          indeterminate
          color="#451646"
        ></v-progress-circular>
        <div
          class=""
          :style="chart_loading ? 'display:none' : 'display:flex'"
          v-if="startsAvg != 0"
        >
          <span slot="this.startsAvg" class="ml-3" to="/agent/rates">
            <a href="/agent/rates" style="color: #383c40; text-decoration: none">
              تقييمات العملاء {{ startsCount }}
            </a>
          </span>
          <span>
            <v-list-item-icon class="ma-0 pa-0" v-for="index in 5" :key="index">
              <v-icon size="25" color="warning"> {{ average_rate_stars(index) }} </v-icon>
            </v-list-item-icon>
          </span>
          <span class="" style="color: #451646; font-weight: 800">
            {{ startsAvg }} .</span
          >
        </div>

        <div class="" :style="chart_loading ? 'display:none' : 'display:flex'" v-else>
          <span slot="this.startsAvg" class="" to="/agent/rates">
            <a href="/agent/rates" style="color: #383c40; text-decoration: none">
              تقييمات العملاء :
            </a>
          </span>

          <span class="" style="color: #451646; font-weight: 500">
            لايوجد تقييمات لديك حتى الآن .</span
          >
        </div>
        <!--
            <highcharts :options="chartOptions" :style="chart_loading ? 'display:none' : 'display:flex'" ></highcharts>
        -->
      </div>
        </v-col>
        <v-col cols="7" v-if="0">
          <div class="d-flex align-center flex-wrap mb-2" style="gap: 8px" v-if="0">
            <DateRanageComponent
              @sendDate="handlePerformanceRangeDate"
              :daysInputChangedTo="performanceFilterObj.dayNumber"
            />
            <v-text-field
              v-if="isCustomerServiceUser"
              label="الايام"
              v-model.number="performanceFilterObj.dayNumber"
              type="number"
              min="1"
              style="width: 80px; height: 48px"
              outlined
              dense
              hide-details
            />
          </div>
          <v-progress-circular
            v-if="performanceLoading"
            :size="30"
            indeterminate
            color="#451646"
          />
          <daily-performance-chart
            v-else
            :performance-data="dailyStats"
          />
        </v-col>
        <v-col cols="2" v-if="0" class="d-flex flex-column justify-center">
          <div
            class=" d-flex  align-right justify-space-between"
            style="gap: 8px; width: 100%"
          >
            <v-chip
              small
              color="info"
              text-color="white"
              class="font-weight-medium"
            >
              تم فتحها: {{ openedCount }}
            </v-chip>
            <v-chip
              small
              color="secondary"
              text-color="white"
              class="font-weight-medium"
            >
              المحدث عليها: {{ updatedCount }}
            </v-chip>
          </div>
        </v-col>
      </v-row>
    </div>

    <v-divider style="opacity: 0.4 !important" color="#451646"></v-divider>

    <div
      class="printing mb-3"
      v-if="$store.state.views !== 'default'"
      style="
        background: white;
        padding: 4px;
        border-radius: 4px !important;
        margin-bottom: 30px !important;
        height: 52px;
        margin-top: 25px;
        display: flex;
        border: 1px solid #ececec;
        margin-left: 3px;
      "
      :style="items.length <= 0 ? 'display:none' : 'display:flex'"
    >
      <div>
        <v-btn
          depressed
          width="40"
          height="40"
          :color="$vuetify.theme.themes.light.dataActionBTN"
          dark
          fab
          class="ml-1 hidden-sm-and-down"
          @click="exportExcel"
          v-if="$store.state.views != 'cards'"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18.116"
            height="18.116"
            viewBox="0 0 12.25 14"
          >
            <g id="excel-file" transform="translate(-1.5)">
              <path
                id="Path_4097"
                data-name="Path 4097"
                d="M11.708,14H1.792a.292.292,0,0,1-.292-.292V3.548a.292.292,0,0,1,.074-.194L4.491.1A.292.292,0,0,1,4.708,0h7A.292.292,0,0,1,12,.292V7a.292.292,0,0,1-.583,0V.583H4.839L2.083,3.659v9.757h9.333V12.25a.292.292,0,1,1,.583,0v1.458A.293.293,0,0,1,11.708,14Z"
                fill="#fff"
              />
              <path
                id="Path_4098"
                data-name="Path 4098"
                d="M4.917,4.292H2.292a.292.292,0,0,1,0-.583H4.625V.792a.292.292,0,0,1,.583,0V4A.292.292,0,0,1,4.917,4.292Zm8.167,8.167h-7a.876.876,0,0,1-.875-.875v-3.5a.876.876,0,0,1,.875-.875h7a.876.876,0,0,1,.875.875v3.5A.876.876,0,0,1,13.083,12.458Zm-7-4.667a.292.292,0,0,0-.292.292v3.5a.292.292,0,0,0,.292.292h7a.293.293,0,0,0,.292-.292v-3.5a.293.293,0,0,0-.292-.292Z"
                transform="translate(-0.208 -0.208)"
                fill="#fff"
              />
              <path
                id="Path_4099"
                data-name="Path 4099"
                d="M11.29,15.67,10.566,14.6h.3a.075.075,0,0,1,.047.012.1.1,0,0,1,.027.03l.572.878a.4.4,0,0,1,.032-.07l.54-.8a.186.186,0,0,1,.03-.036.058.058,0,0,1,.039-.012h.283l-.726,1.052.751,1.139h-.293a.079.079,0,0,1-.053-.017.176.176,0,0,1-.031-.038l-.588-.919a.316.316,0,0,1-.027.061l-.572.858a.21.21,0,0,1-.032.039.065.065,0,0,1-.05.018h-.275l.755-1.125Zm1.754.876h.948V16.8H12.747V14.6h.3Zm2.4-1.6a.117.117,0,0,1-.03.034.059.059,0,0,1-.039.012.111.111,0,0,1-.061-.026q-.042-.031-.086-.058a.805.805,0,0,0-.128-.057.558.558,0,0,0-.18-.026.575.575,0,0,0-.176.027.377.377,0,0,0-.128.073.279.279,0,0,0-.076.109.348.348,0,0,0-.026.134.243.243,0,0,0,.045.152.385.385,0,0,0,.119.1.952.952,0,0,0,.168.074l.193.065c.065.023.131.048.192.075a.658.658,0,0,1,.168.107.486.486,0,0,1,.12.158.515.515,0,0,1,.045.229.735.735,0,0,1-.049.269.632.632,0,0,1-.143.22.672.672,0,0,1-.231.146.849.849,0,0,1-.311.054.956.956,0,0,1-.389-.077.908.908,0,0,1-.3-.209l.086-.14a.107.107,0,0,1,.03-.029.07.07,0,0,1,.038-.012.118.118,0,0,1,.073.034.946.946,0,0,0,.1.076.608.608,0,0,0,.366.107.577.577,0,0,0,.188-.029.378.378,0,0,0,.258-.373.269.269,0,0,0-.045-.163.38.38,0,0,0-.118-.106.832.832,0,0,0-.167-.072l-.192-.061a2.009,2.009,0,0,1-.192-.073.608.608,0,0,1-.167-.109.484.484,0,0,1-.118-.164.571.571,0,0,1-.045-.244.579.579,0,0,1,.177-.418.622.622,0,0,1,.211-.134.75.75,0,0,1,.29-.05.921.921,0,0,1,.335.058.773.773,0,0,1,.264.169l-.072.141Z"
                transform="translate(-3.765 -6.075)"
                fill="#fff"
              />
            </g>
          </svg>
        </v-btn>
        <v-btn
          depressed
          width="42"
          height="42"
          @click="printNow"
          :color="$vuetify.theme.themes.light.dataActionBTN"
          fab
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18.116"
            height="18.116"
            viewBox="0 0 16.116 16.116"
          >
            <g
              id="Icon_feather-printer"
              data-name="Icon feather-printer"
              transform="translate(-2.5 -2.5)"
            >
              <path
                id="Path_4011"
                data-name="Path 4011"
                d="M9,8.291V3h9.069V8.291"
                transform="translate(-2.977)"
                fill="none"
                stroke="#fff"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1"
              />
              <path
                id="Path_4012"
                data-name="Path 4012"
                d="M6.023,20.3H4.512A1.512,1.512,0,0,1,3,18.791V15.012A1.512,1.512,0,0,1,4.512,13.5H16.6a1.512,1.512,0,0,1,1.512,1.512v3.779A1.512,1.512,0,0,1,16.6,20.3H15.093"
                transform="translate(0 -5.209)"
                fill="none"
                stroke="#fff"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1"
              />
              <path
                id="Path_4013"
                data-name="Path 4013"
                d="M9,21h9.069v6.046H9Z"
                transform="translate(-2.977 -8.931)"
                fill="none"
                stroke="#fff"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1"
              />
            </g>
          </svg>
        </v-btn>
        <v-spacer class="top-spacer" />
      </div>
    </div>
    <div
      style="margin-bottom: 40px"
      class="table__view"
      v-if="$store.state.views == 'table'"
    >
      <table-component
        :showSelect="true"
        :pagination="pagination"
        itemKey="id"
        :selectedRows.sync="selected_requests"
        @refresh="get_all_requests"
        :headers="headers"
        :items="items"
        :loading="loading"
        v-model="page"
      >
        <!-- eslint-disable -->
        <template v-slot:[`item.action`]="{ item }">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="#3f0e40" depressed small dark v-bind="attrs" v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <router-link
                style="text-decoration: none"
                :to='{ name: (isCustomerServiceUser) ? "customer_service_request_details" : "request_details", params: { id: item.id } }'
              >
                <v-list-item>
                  <v-list-item-icon class="ml-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18.528"
                      height="15.111"
                      viewBox="0 0 13.528 10.111"
                    >
                      <g
                        id="Icon_feather-eye-dark"
                        data-name="Icon feather-eye-dark"
                        transform="translate(-1 -5.5)"
                      >
                        <path
                          id="Path_4040"
                          data-name="Path 4040"
                          d="M1.5,10.556S3.778,6,7.764,6s6.264,4.556,6.264,4.556-2.278,4.556-6.264,4.556S1.5,10.556,1.5,10.556Z"
                          fill="none"
                          :stroke="$store.getters.isDark ? '#fff' : '#2c2c2c'"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="1"
                        />
                        <path
                          id="Path_4041"
                          data-name="Path 4041"
                          d="M16.917,15.208A1.708,1.708,0,1,1,15.208,13.5,1.708,1.708,0,0,1,16.917,15.208Z"
                          transform="translate(-7.444 -4.653)"
                          fill="none"
                          :stroke="$store.getters.isDark ? '#fff' : '#2c2c2c'"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="1"
                        />
                      </g>
                    </svg>
                  </v-list-item-icon>
                  <v-list-item-title>فتح</v-list-item-title>
                </v-list-item>
              </router-link>

              <v-list-item @click="getRequestCalls(item)">
                <v-list-item-icon class="ml-3">
                  <RequestCallsIcon />
                </v-list-item-icon>
                <v-list-item-title>المكالمات</v-list-item-title>
              </v-list-item>

              <router-link
                style="text-decoration: none"
                target="_blank"
                :to='{ name: (isCustomerServiceUser) ? "customer_service_request_details" : "request_details", params: { id: item.id } }'
              >
                <v-list-item>
                  <v-list-item-icon class="ml-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18.528"
                      height="15.111"
                      viewBox="0 0 13.528 10.111"
                    >
                      <g
                        id="Icon_feather-eye-dark"
                        data-name="Icon feather-eye-dark"
                        transform="translate(-1 -5.5)"
                      >
                        <path
                          id="Path_4040"
                          data-name="Path 4040"
                          d="M1.5,10.556S3.778,6,7.764,6s6.264,4.556,6.264,4.556-2.278,4.556-6.264,4.556S1.5,10.556,1.5,10.556Z"
                          fill="none"
                          :stroke="$store.getters.isDark ? '#fff' : '#2c2c2c'"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="1"
                        />
                        <path
                          id="Path_4041"
                          data-name="Path 4041"
                          d="M16.917,15.208A1.708,1.708,0,1,1,15.208,13.5,1.708,1.708,0,0,1,16.917,15.208Z"
                          transform="translate(-7.444 -4.653)"
                          fill="none"
                          :stroke="$store.getters.isDark ? '#fff' : '#2c2c2c'"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="1"
                        />
                      </g>
                    </svg>
                  </v-list-item-icon>
                  <v-list-item-title> فتح في تاب جديد</v-list-item-title>
                </v-list-item>
              </router-link>
              <v-list-item @click="to_tickets_page(item)">
                <v-list-item-icon class="ml-3">
                  <svg
                    class="ml-2"
                    xmlns="http://www.w3.org/2000/svg"
                    width="23.194"
                    height="23.212"
                    viewBox="0 0 23.194 23.212"
                  >
                    <g id="ticket_menu" data-name="ticket menu" transform="translate(0)">
                      <path
                        id="Path_2758"
                        data-name="Path 2758"
                        d="M93.931,77.839a.631.631,0,0,0-.8-.076,2.521,2.521,0,0,1-3.493-3.506.638.638,0,0,0-.076-.795l-.725-.725A2.525,2.525,0,0,0,87.051,72h0a2.525,2.525,0,0,0-1.785.738L72.92,85.123a2.525,2.525,0,0,0,.006,3.563l.486.479a.636.636,0,0,0,.845.044,2.5,2.5,0,0,1,3.525,3.519.631.631,0,0,0,.038.851l.9.9a2.527,2.527,0,0,0,3.569,0h0l12.36-12.36a2.527,2.527,0,0,0,0-3.569ZM81.382,93.579a1.264,1.264,0,0,1-1.785,0l-.517-.517A3.758,3.758,0,0,0,73.929,87.9l-.107-.107a1.264,1.264,0,0,1,0-1.785l8.406-8.437,7.58,7.58Zm12.36-12.36L90.69,84.271l-7.58-7.586,3.039-3.052a1.24,1.24,0,0,1,.889-.372h0a1.26,1.26,0,0,1,.889.366l.385.385a3.788,3.788,0,0,0,5.064,5.064l.359.359a1.258,1.258,0,0,1,.006,1.785Z"
                        transform="translate(-72.187 -72)"
                        :fill="$route.name == 'tickets' ? '#fff' : '#2c2c2c'"
                      />
                      <path
                        id="Path_2759"
                        data-name="Path 2759"
                        d="M171.445,217.177l-3.058-3.058a1.264,1.264,0,0,0-1.785,0h0l-2.983,2.983a1.264,1.264,0,0,0,0,1.785l3.058,3.058a1.264,1.264,0,0,0,1.785,0l2.983-2.983a1.249,1.249,0,0,0,.032-1.772C171.47,217.177,171.463,217.171,171.445,217.177Zm-3.872,3.872-3.065-3.058,2.983-2.983h0l3.058,3.058Z"
                        transform="translate(-157.508 -204.811)"
                        :fill="$route.name == 'tickets' ? '#fff' : '#2c2c2c'"
                      />
                    </g>
                  </svg>
                </v-list-item-icon>
                <v-list-item-title>التذاكر</v-list-item-title>
              </v-list-item>
              <v-list-item @click="to_chat_page(item)">
                <v-list-item-icon class="ml-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="17.599"
                    height="18.22"
                    viewBox="0 0 17.599 18.22"
                  >
                    <g id="chat" transform="translate(-2.1 -1.2)">
                      <path
                        id="Path_2760"
                        data-name="Path 2760"
                        d="M11.565,37.775a3.256,3.256,0,0,0-2.366-1.6c-.769-.207-.739-.5-.71-.739l.059-.118a.029.029,0,0,1,.03-.03c.03-.059.089-.118.118-.177A1.807,1.807,0,0,0,8.9,34.7c.03-.059.03-.118.059-.177,0-.03.03-.059.03-.089l.089-.089.207-.237.03-.03a1.289,1.289,0,0,0,.177-.5v-.089c0-.089.03-.148.03-.237v-.177a.782.782,0,0,0-.3-.621.267.267,0,0,1,.03-.148,2.252,2.252,0,0,0,.089-.621,1.673,1.673,0,0,0-.237-.946,1.881,1.881,0,0,0-.8-.71c-.059-.03-.148-.059-.207-.089a3.218,3.218,0,0,0-1.183-.207H6.655a2.493,2.493,0,0,0-.887.177c-.03.03-.089.03-.089.059a1.023,1.023,0,0,0-.325.3l-.03.059c-.03.059-.03.059-.059.059a.394.394,0,0,1-.148.089.64.64,0,0,0-.355.325,1.889,1.889,0,0,0-.177.651,5.013,5.013,0,0,0,.03.651c0,.089.03.177.03.266v.03a.618.618,0,0,0-.325.621v.207c0,.089.03.177.03.237v.089a1.267,1.267,0,0,0,.148.473c.059.089.089.148.148.177a.784.784,0,0,0,.177.148,2.8,2.8,0,0,0,.325.739v.03l.03.03.059.089.03.03c.03.03.03.03.03.059l.03.03v.03c.03.207.089.5-.71.739a3.529,3.529,0,0,0-2.366,1.6,1.955,1.955,0,0,0-.148.769v.562a.392.392,0,0,0,.385.385h0a.392.392,0,0,0,.385-.385v-.532a1.854,1.854,0,0,1,.059-.473c.266-.621,1.183-.976,1.893-1.183q1.464-.4,1.242-1.6a.657.657,0,0,0-.148-.325l-.03-.03c0-.03-.03-.03-.03-.059L5.738,34.7a3.205,3.205,0,0,1-.237-.562.6.6,0,0,0-.237-.355l-.059-.03c-.03,0-.03-.03-.059-.059a.1.1,0,0,1-.03-.059.42.42,0,0,1-.059-.177l.059-.118c0-.059-.03-.118-.03-.177v-.089h.059l.089-.03a.462.462,0,0,0,.207-.385,1.746,1.746,0,0,0-.059-.414c0-.059-.03-.118-.03-.177a1.766,1.766,0,0,1,0-.562.636.636,0,0,1,.059-.3A1.221,1.221,0,0,0,5.738,31a.68.68,0,0,0,.207-.237l.03-.059a.231.231,0,0,1,.118-.118,2.1,2.1,0,0,1,.621-.118h.207a2.3,2.3,0,0,1,.917.177c.059.03.089.03.148.059a.821.821,0,0,1,.444.385,1.013,1.013,0,0,1,.118.532,2.589,2.589,0,0,1-.059.473,1.006,1.006,0,0,0-.03.3v.089a.505.505,0,0,0,.03.355.529.529,0,0,0,.3.266v.089a.375.375,0,0,1-.03.177.178.178,0,0,1-.03.118.25.25,0,0,1-.059.177l-.03.03-.059.03-.207.207a.879.879,0,0,0-.177.385c0,.03,0,.059-.03.059a2.748,2.748,0,0,1-.148.3c-.03.03-.03.059-.059.089l-.207.3a.557.557,0,0,0-.059.237q-.222,1.2,1.242,1.6a2.793,2.793,0,0,1,1.893,1.183,1.3,1.3,0,0,1,.059.473v.532a.373.373,0,0,0,.385.385h0a.392.392,0,0,0,.385-.385v-.562A1.135,1.135,0,0,0,11.565,37.775Zm-.237,1.568Zm8.37-.8a1.865,1.865,0,0,0-.148-.769,3.256,3.256,0,0,0-2.4-1.6c-.769-.207-.739-.5-.71-.739l.059-.148.03-.03c.03-.059.089-.118.118-.177a2.686,2.686,0,0,0,.207-.414,1.233,1.233,0,0,0,.059-.177V34.4c.03-.03.059-.059.089-.059l.03-.03.03-.03.177-.207.03-.03a1.289,1.289,0,0,0,.177-.5v-.089c0-.089.03-.148.03-.237v-.177a.782.782,0,0,0-.3-.621.267.267,0,0,1,.03-.148,2.607,2.607,0,0,0,.089-.621,1.673,1.673,0,0,0-.237-.946,1.881,1.881,0,0,0-.8-.71v-.03a.5.5,0,0,0-.148-.059,3.113,3.113,0,0,0-1.183-.207H14.67a2.06,2.06,0,0,0-.887.177c-.059.03-.089.059-.118.059a1.55,1.55,0,0,0-.325.3l-.03.089-.03.03a.029.029,0,0,1-.03.03.27.27,0,0,1-.148.089.64.64,0,0,0-.355.325,1.889,1.889,0,0,0-.177.651V32.1c0,.089.03.177.03.266v.03a.618.618,0,0,0-.325.621v.177a.912.912,0,0,0,.03.266v.089a2.216,2.216,0,0,0,.148.473c.059.059.089.148.148.177a.784.784,0,0,0,.177.148,2.43,2.43,0,0,0,.325.739v.03l.089.118.03.03c.03.03.03.03.03.059l.03.059c.03.207.089.5-.71.739a6.474,6.474,0,0,0-1.213.473l-.03.03a3.545,3.545,0,0,1,.5.621,5.782,5.782,0,0,1,.946-.355q1.464-.4,1.242-1.6a.657.657,0,0,0-.148-.325l-.03-.03c0-.03-.03-.03-.03-.059l-.118-.148a3.205,3.205,0,0,1-.237-.562.589.589,0,0,0-.237-.355l-.059-.03a.064.064,0,0,1-.059-.059.1.1,0,0,1-.03-.059.42.42,0,0,1-.059-.177l.089-.148c0-.059-.03-.118-.03-.177v-.089h.059l.089-.03a.4.4,0,0,0,.207-.385,1.79,1.79,0,0,0-.059-.444c0-.059-.03-.089-.03-.148a1.766,1.766,0,0,1,0-.562.742.742,0,0,1,.059-.3h0A1.99,1.99,0,0,0,13.724,31a1.293,1.293,0,0,0,.207-.237l.03-.059a.231.231,0,0,1,.118-.118,1.75,1.75,0,0,1,.592-.118h.207a2.3,2.3,0,0,1,.917.177c.059.03.089.03.148.059a.941.941,0,0,1,.444.385,1.013,1.013,0,0,1,.118.532,2.589,2.589,0,0,1-.059.473.819.819,0,0,0-.03.266v.089a.505.505,0,0,0,.03.355.529.529,0,0,0,.3.266v.089a.375.375,0,0,1-.03.177l-.03.118a.269.269,0,0,1-.089.207l-.03.089-.177.177a.842.842,0,0,0-.177.414c0,.03,0,.03-.03.059a1.363,1.363,0,0,1-.148.3c0,.03-.03.059-.059.089h-.03l-.089.148-.059.089v.059a.557.557,0,0,0-.059.237q-.222,1.2,1.242,1.6A2.793,2.793,0,0,1,18.87,38.1a1.34,1.34,0,0,1,.089.473v.532a.413.413,0,0,0,.089.266.321.321,0,0,0,.266.118h0a.373.373,0,0,0,.385-.385v-.118C19.7,38.6,19.7,38.544,19.7,38.544Z"
                        transform="translate(0 -20.07)"
                        fill="#383c40"
                      />
                      <path
                        id="Path_2761"
                        data-name="Path 2761"
                        d="M10.973,9.008a.467.467,0,0,1-.473-.473V3.359A2.168,2.168,0,0,1,12.659,1.2h.03c1.183.03,1.923,0,2.78,0h1.508a2.184,2.184,0,0,1,1.331.444,2.135,2.135,0,0,1,.858,1.627A4.13,4.13,0,0,1,18.9,5.1a3.371,3.371,0,0,1-.532.887A3.54,3.54,0,0,1,16.5,7.263a3.207,3.207,0,0,1-1.065.148H12.748L11.683,8.476l-.355.355A.416.416,0,0,1,10.973,9.008Zm1.686-7.069a1.444,1.444,0,0,0-1.449,1.42V7.973l1.035-1.035.03-.03a.584.584,0,0,1,.414-.177h2.751a3.849,3.849,0,0,0,.887-.118,3.017,3.017,0,0,0,1.479-1.035,2.622,2.622,0,0,0,.414-.739A4.216,4.216,0,0,0,18.427,3.3a1.346,1.346,0,0,0-.562-1.094,1.4,1.4,0,0,0-.887-.3H15.5c-.917.03-1.656.03-2.839.03Z"
                        transform="translate(-5.916)"
                        fill="#383c40"
                      />
                      <path
                        id="Path_2762"
                        data-name="Path 2762"
                        d="M41.568,3.511V8.6a.424.424,0,0,1-.148.325.445.445,0,0,1-.325.118.62.62,0,0,1-.325-.118l-.562-.562c-.3-.3-.562-.562-.769-.739H36.421a1.109,1.109,0,0,1-.325-.03l-.3-.03a5.069,5.069,0,0,0,.739-.651h2.928a.584.584,0,0,1,.414.177l.03.03.562.562.266.266.089.059v-4.5A1.3,1.3,0,0,0,39.5,2.21H37.279a2.04,2.04,0,0,0-.532-.71h2.78A2.035,2.035,0,0,1,41.568,3.511Z"
                        transform="translate(-23.732 -0.211)"
                        fill="#383c40"
                      />
                    </g>
                  </svg>
                </v-list-item-icon>
                <v-list-item-title>محادثة العميل</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template slot="item.agent_date" slot-scope="props">
          <div>{{ props.item.agent_date.split(" ")[0] }}</div>
          <div>{{ props.item.agent_date.split(" ")[1].split(".")[0] }}</div>
        </template>
        <template slot="item.agent_notes" slot-scope="props">
          <span v-if="!props.item.agent_notes"></span>
          <v-tooltip bottom v-else>
            <template v-slot:activator="{ on }">
              <span v-on="on">{{ props.item.agent_notes.substring(0, 25) + "..." }}</span>
            </template>
            <div class="font-weight-bold">{{ props.item.agent_notes }}</div>
          </v-tooltip>
        </template>
        <template slot="item.quality_notes" slot-scope="props">
          <span v-if="!props.item.quality_notes"></span>
          <v-tooltip bottom v-else>
            <template v-slot:activator="{ on }">
              <span v-on="on">{{
                props.item.quality_notes.substring(0, 25) + "..."
              }}</span>
            </template>
            <div class="font-weight-bold">{{ props.item.quality_notes }}</div>
          </v-tooltip>
        </template>
        <template slot="item.source" slot-scope="props">
          {{ work_source(parseInt(props.item.source))
          }}{{ props.item.source == 2 ? ` - ${props.item.collaborator_name}` : "" }}
        </template>
        <template slot="item.customer_name" slot-scope="props">
          {{ props.item.customer?.name }}
        </template>
      </table-component>
    </div>

    <div v-else-if="$store.state.views === 'default'">
      <div v-if="defaultViewData.length > 0" style="margin-top: -25px">
        <DefaultView
          :CardData="defaultViewData"
          @pageCount="handlePageNumber"
          name="cs_all"
        />
      </div>
      <div>
        <LoadingMore v-if="loadMoreData" style="margin: 40px" />
      </div>
    </div>
    <!-- Cards -->
    <div v-else-if="$store.state.views === 'cards'">
      <CardsStyle :tableData="items" />
    </div>
    <!-- Cards -->
    <AddNewRequestBtn />
    <AgentChat />
    <CallsDialog />
  </div>
</template>

<script>
import Axios from "axios";
import CardsStyle from "@/components/Base/CSCardsStyle.vue";
import AddNewRequestBtn from "../Charts/AddNewRequestBtn.vue";
import AgentChat from "@/components/AgentChat/AgentChat.vue";
import { Chart } from "highcharts-vue";
import { RequestCallsIcon } from "@/assets/adminIcons/requestCalls";
import CallsDialog from "@/components/Charts/CallsDialog.vue";
import DefaultView from "../Base/DefaultView.vue";
import LoadingMore from "../Charts/LoadingMore.vue";
import DailyPerformanceChart from "@/components/dashboard/DailyPerformanceChart.vue";
import DateRanageComponent from "@/components/Charts/DateRangeComponent.vue";

export default {
  name: "HelloWorld",
  components: {
    CardsStyle,
    AddNewRequestBtn,
    AgentChat,
    RequestCallsIcon,
    CallsDialog,
    DefaultView,
    LoadingMore,
    DailyPerformanceChart,
    DateRanageComponent,
  },
  data: () => ({
    loading: false,
    pagination: {},
    headers: [
      // { text: "تاريخ الطلب", value: "req_date", align: "center", width: "120px" },
      { text: "نوع الطلب", value: "type", align: "center" },
      { text: "عميل", value: "customer_name", align: "center" },
      { text: "حالة الطلب", value: "status", align: "center" },
      // { text: "مصدر المعامله", value: "source", align: "center" },
      // { text: "تصنيف المعامله", value: "class_id_agent_text", align: "center" },
      { text: "الملاحظه", value: "agent_notes", align: "center" },
      { text: "ملاحظة الجوده", value: "quality_notes", align: "center" },
      { text: "تاريخ الاستشاري", value: "agent_date", align: "center" },
      { text: "العمليات", value: "action", width: "1%", align: "center" },
    ],
    page: 1,
    /* eslint-disable */
    items: [],
    addNewRequestDialog: false,
    selected_requests: [],
    defaultViewData: [],
    chart_loading: true,
    startsAvg: 0.0,
    startsCount: 0,
    startsAvgFlag: true,
    chartOptions: {},
    loadMoreData: false,
    performanceLoading: false,
    dailyStats: [],
    performanceFilterObj: {
      startDate: new Date().toISOString().slice(0, 10),
      endDate: new Date().toISOString().slice(0, 10),
      dayNumber: "",
    },
    openedCount: 0,
    updatedCount: 0,
  }),
  computed: {
    isCustomerServiceUser() {
      return (
        localStorage.getItem("role") === "0" &&
        localStorage.getItem("is_customer_service") === "1"
      );
    },
  },
  methods: {
    async get_all_requests(page = 1, type) {
      this.loading = true;
      this.loadMoreData = true;
      await Axios.get(
        `${this.$store.state.url}/v2/employee/Requests?type=all&page=${page}&per_page=${this.$store.state.counterOfShow}`,
        {
          headers: this.request_headers(),
        }
      ).then((response) => {
        if (page === 1 || type === "table") {
          this.items = response.data.payload.data;
        }

        this.defaultViewData.push(...response.data.payload.data);
        this.pagination = {
          limit: 12,
          count: response.data.payload.count_of_all,
        };
        this.loading = false;
        this.loadMoreData = false;
      });
    },

    to_request_details(item) {
      this.$router.push({
        name: "request_details",
        params: { id: item.id },
      });
    },

    getRequestCalls(item) {
      this.$store.state.idOfRequestCalls = item.id;
      this.$store.state.openCallsDialog = true;
    },

    average_rate_stars(index) {
      if (index <= this.startsAvg) {
        return "mdi-star";
      } else if (Math.round(this.startsAvg) == index) {
        return "mdi-star-half-full";
      } else {
        return "mdi-star-outline";
      }
      /*
      if (this.startsAvg == 0){
        return;
      }
      var afn = this.startsAvg;

      var first_number = parseInt(afn.toString().substring(0));
      if(first_number == 0 && index == 1)
        this.startsAvgFlag = true;

      if (index <= afn){
        this.startsAvgFlag = true;
        return 'mdi-star';
      }
      else if (this.startsAvgFlag && afn.toString().includes('.')){
        let substring_avg = parseInt(afn.toString().substring(2,3));
        if (substring_avg > 3 ){
          this.startsAvgFlag = false;
          return 'mdi-star-half-full';
        }
      }
      return 'mdi-star-outline';*/
    },
    to_tickets_page(item) {
      this.$router.push({ name: "tickets", params: { id: item.id } });
    },
    exportExcel() {
      const table = document.querySelector(".all-requests table");
      this.exportTableToCsv(table, "جميع الطلبات");
    },
    printNow() {
      this.items.forEach((data) => {
        data.customer_name = data.customer.name;
      });
      this.printTable(this.items, this.headers, "جدول جميع الطلبات");
    },
    to_chat_page(item) {
      this.$router.push({
        name: "chat_component",
        query: {
          customer_name: item.customer.name,
          customer_id: item.customer.id,
          request_id: item.id,
        },
      });
    },
    async to_rate_report() {
      await Axios.get(`${this.$store.state.url}/employee/rates/report`, {
        headers: this.request_headers(),
      }).then((response) => {
        response = response.data.payload.data;
        let avg = response.avg;
        this.startsAvg = avg;
        let count = response.count;
        this.startsCount = count;
        // let rest = 5 - avg;
        this.chart_loading = false;
        //this.chartOptions= {
        //  chart: {
        //      plotBackgroundColor: null,
        //      plotBorderWidth: 0,
        //      plotShadow: false,
        //      width: 300,
        //      height: 280,
        //  },
        //  title: {
        //      text: 'نتيجة متوسط تقييمك',
        //  },
        //  subtitle: {
        //      text: '<span style="color:#451646;font-size:large"> مجموع التقييمات : </span>' + '<span style="color:#222a5d;font-size:large;font-weight:500"> '+ count +' </span>',
        //      align: 'center',
        //      verticalAlign: 'middle',
        //      y: 100,
        //      color: '#451646',
        //      useHTML:true
        //  },
        //  plotOptions: {
        //      pie: {
        //          dataLabels: {
        //              enabled: true,
        //              distance: 10,
        //              style: {
        //                  fontWeight: '',
        //                  fontSize: 12,
        //                  color: '#451646',
        //                  align: 'left'
        //              }
        //          },
        //          startAngle: -90,
        //          endAngle: 90,
        //          center: ['50%', '55%'], //location of pie (left,top)
        //          size: '85%', //size of pie
        //          colors: [ "#3f0e40" , "#e09de1" , "#383c40"],
        //      }
        //  },
        //  tooltip: {
        //  formatter() {
        //    return `
        //      ${this.key} : ${this.y}
        //    `;
        //  },
        //  },
        //  series: [{
        //      type: 'pie',
        //      innerSize: '50%',
        //      data: [
        //          ['متوسط تقييمك', avg],
        //          {
        //              name: 'الباقي',
        //              y: rest,
        //              dataLabels: {
        //                  enabled: false
        //              }
        //          }
        //      ]
        //  }]
        //}
      });
    },

    handlePageNumber(val) {
      this.get_all_requests(val);
    },

    getDefaultPerformanceColors() {
      return {
        Received: "#3B82F6",
        New: "#8B5CF6",
        Followed: "#F59E0B",
        Archived: "#EF4444",
        Completed: "#10B981",
      };
    },

    normalizePerformancePayload(payload) {
      const colors = this.getDefaultPerformanceColors();
      if (!payload || typeof payload !== "object") {
        return [];
      }
      if (Array.isArray(payload.data)) {
        return payload.data.map((item) => ({
          name: item.name || "",
          color: item.color || colors[item.name] || "#6B7280",
          value: Number(item.value) || 0,
        }));
      }
      const order = ["Received", "New", "Followed", "Archived", "Completed"];
      const valueGetters = {
        Received: () =>
          payload.received ??
          payload.received_basket?.count ??
          payload["المستلمة"],
        New: () =>
          payload.new ?? payload.new_request?.count ?? payload["الطلبات الجديدة"],
        Followed: () =>
          payload.followed ??
          payload.followed_basket?.count ??
          payload["المتابعة"],
        Archived: () =>
          payload.archived ??
          payload.archived_basket?.count ??
          payload["المؤرشفة"],
        Completed: () =>
          payload.completed ??
          payload.completed_request?.count ??
          payload["المكتملة"],
      };
      return order.map((name) => {
        const raw = valueGetters[name] ? valueGetters[name]() : payload[name];
        const value = Number(raw);
        return {
          name,
          color: colors[name] || "#6B7280",
          value: Number.isFinite(value) ? value : 0,
        };
      });
    },

    handlePerformanceRangeDate(val) {
      this.performanceFilterObj.startDate = val.startDate || "";
      this.performanceFilterObj.endDate = val.endDate || "";
      if (this.performanceFilterObj.dayNumber === 1) {
        this.performanceFilterObj.dayNumber = "";
      }
      this.fetch_agent_performance();
    },

    async fetch_agent_performance() {
      this.performanceLoading = true;
      const url = `${this.$store.state.url}/agent/performance`;
      // start_date=2026-03-01&end_date=2026-03-18
      const body = {
            start_date: '2026-03-01',
            end_date: '2026-03-18'
      };
      if (this.performanceFilterObj.startDate) {
        body.start_date = this.performanceFilterObj.startDate;
      }
      if (this.performanceFilterObj.endDate) {
        body.end_date = this.performanceFilterObj.endDate;
      }
      try {
        const response = await Axios.post(url, body, {
          headers: this.request_headers(),
        });
        const payload = response.data?.payload ?? response.data;
        this.dailyStats = this.normalizePerformancePayload(payload) || [];
        this.openedCount =
          Number(
            payload?.opened_request?.count ??
              payload?.opened_request ??
              payload["تم فتحها"]
          ) || 0;
        this.updatedCount =
          Number(
            payload?.updated_request?.count ??
              payload?.updated_request ??
              payload["المحدث عليها"]
          ) || 0;
      } catch (err) {
        this.dailyStats = [];
        this.openedCount = 0;
        this.updatedCount = 0;
      } finally {
        this.performanceLoading = false;
      }
    },
  },
  async created() {
    this.$store.state.opened = -1;
    await this.get_all_requests(1);
  },
  mounted() {
    if (localStorage["role"] && localStorage["role"] == "0") {
      this.$store.state.views = "default";
    }
    this.to_rate_report();
    this.fetch_agent_performance();
  },
  watch: {
    "performanceFilterObj.dayNumber"(newVal, oldVal) {
      if (newVal !== oldVal && Number(newVal) > 0) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const startDate = new Date(today);
        startDate.setDate(startDate.getDate() - Number(newVal) + 1);
        this.performanceFilterObj.startDate = startDate
          .toISOString()
          .slice(0, 10);
        this.performanceFilterObj.endDate = today.toISOString().slice(0, 10);
        this.fetch_agent_performance();
      }
    },
    page(val) {
      this.get_all_requests(val, "table");
    },
    selected_requests(val) {
      this.$emit("requests", val);
    },
    // Task 146
    "$store.state.count_of_archived_in_quality": {
      handler(val) {
        if (val > this.$store.state.redirect_count_of_archived_in_quality && localStorage["role"] == "0") {
          this.$store.state.showAlertOfArchivedQualityDidntProccess = true;
          this.$router.push({ name: "archievedInQuality" });
        }
      },
      immediate: true
    },
    "$store.state.counterOfShow": {
      handler(newval, oldvalue) {
        if (newval != oldvalue) {
          this.get_all_requests(this.page);
        }
      },
    },

    "$store.state.first_not_processed_task_id": {
      handler(val) {
        if (val > 0 && localStorage["role"] == "0") {
          this.$store.state.showAlertOfTasksDidntProccess = true;
          this.$router.push({ name: 'ticket_details', params: { ticket: this.$store.state.first_not_processed_task_id } });
        }
      },
      immediate: true 
    },

    $route: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$store.state.counterOfShow = 10;
        }
      },
    },
  },
};
</script>
